import React, { useState, useCallback } from 'react';
import './Contact.css';
import linkedinIcon from '../../assets/socials/3d-icon-linkedin.png';
import githubIcon from '../../assets/socials/3d-icon-github.png';
import facebookIcon from '../../assets/socials/3d-icon-facebook.png';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const emailAddress = 'luigisantiago231@gmail.com';

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(emailAddress).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  }, [emailAddress]);

  return (
    <section id="contact" className="contact-section">
      <div className="contact-card">
        <div className="contact-ambient-glow"></div>

        <div className="contact-header">
          <span className="section-tag">Get in Touch</span>
          <h2 className="contact-title">Let's build something exceptional together.</h2>
          <p className="contact-subtitle">
            Have a project in mind, an opportunity to discuss, or want to collaborate? Reach out anytime — I'd love to connect.
          </p>
        </div>

        {/* Email Copy Card */}
        <div className="contact-email-bar">
          <div className="email-info">
            <span className="email-label">Direct Email</span>
            <span className="email-address">{emailAddress}</span>
          </div>

          <div className="email-actions">
            <button
              className={`btn btn-secondary copy-btn ${copied ? 'copied' : ''}`}
              onClick={copyToClipboard}
              aria-label="Copy email address"
            >
              {copied ? (
                <>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  <span>Copied!</span>
                </>
              ) : (
                <>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                  <span>Copy</span>
                </>
              )}
            </button>

            <a href={`mailto:${emailAddress}`} className="btn btn-primary send-btn">
              Send Email
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </a>
          </div>
        </div>

        {/* Social Connection Pills */}
        <div className="contact-socials-wrap">
          <span className="socials-lead">Or connect via social channels:</span>
          <div className="contact-social-pills">
            <a
              href="https://github.com/Wigibles"
              className="social-card-pill"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={githubIcon} alt="GitHub" className="social-pill-icon" />
              <span>GitHub</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </a>

            <a
              href="https://www.linkedin.com/in/luigiatlinkdin/"
              className="social-card-pill"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-pill-icon" />
              <span>LinkedIn</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </a>

            <a
              href="https://www.facebook.com/luigisantiago231"
              className="social-card-pill"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="Facebook" className="social-pill-icon" />
              <span>Facebook</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </a>
          </div>
        </div>

        {/* Location & Timezone info */}
        <div className="contact-meta-footer">
          <span className="location-pill">
            <span className="location-dot"></span>
            Philippines • GMT+8
          </span>
        </div>
      </div>
    </section>
  );
};

export default Contact;